<script lang="ts">
    import CalculatorBox from "./components/CalculatorBox.svelte";
    import CalculatorSeparator from "./components/CalculatorSeparator.svelte";
    import CalculatorSection from "./components/CalculatorSection.svelte";
    import CalculatorMaxMinAvgResult from "./components/results/CalculatorMaxMinAvgResult.svelte";
    import CalculatorDieRollInput from "./components/inputs/CalculatorDieRollInput.svelte";
    import type { DiceRoll } from "../lib/dice_rolls";

    let diceRoll: DiceRoll | null = null;
    let diceText: string | null = null;
    $: if (diceRoll !== null) {
        diceText = diceRoll.asText();
    }
</script>

<CalculatorBox>
    <div>
        <CalculatorSection>
            <p class="font-size-1-2-rem">Given a dice roll of...</p>
            <CalculatorDieRollInput bind:diceRoll />
        </CalculatorSection>
        <CalculatorSeparator />
        <CalculatorSection>
            <div>
                {#if diceText === null}
                    <p class="font-size-1-2-rem">
                        <em>Introduce a die roll to see results...</em>
                    </p>
                {:else}
                    <p class="font-size-1-2-rem">
                        The expected results of <span
                            class="font-size-1-5-rem font-family-bardic-sans">{diceText}</span
                        > are...
                    </p>
                {/if}
            </div>
            <CalculatorMaxMinAvgResult roll={diceRoll} />
        </CalculatorSection>
    </div>
</CalculatorBox>
